

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FileViewer from './FileViewer';
import { Loading } from 'shared';
import {
    fetchIasPdfAndImages,
    clearDocuments
} from './IasPdfAndImages';
export default function IasEhrData({ ssn }) {
    const dispatch = useDispatch();

    const documents = useSelector(state => state.iasPdfAndImages.documents);
    const loading = useSelector(state => state.iasPdfAndImages.loading);
    const error = useSelector(state => state.iasPdfAndImages.error);

    const [inputInvalid, setInputInvalid] = useState(false);

    useEffect(() => {
        const isValidPayload = ssn ;
        if (!isValidPayload) {
            setInputInvalid(true);
            return;
        }

        setInputInvalid(false);

        if (documents && documents.length > 0) {
            return;
        }

        if (!loading && !error) {
            const payload = {
                value: ssn,
                status: "current"
            };
            console.log(payload);
            dispatch(fetchIasPdfAndImages(payload));
        }
    }, [dispatch, ssn, documents, loading, error]);

    const handleRefresh = () => {
        const isValidPayload = ssn ;
        if (!isValidPayload) {
            setInputInvalid(true);
            return;
        }
        setInputInvalid(false);
        dispatch(clearDocuments());
        const payload = {
            value: ssn,
            status: "current"
        };
        dispatch(fetchIasPdfAndImages(payload));
    };

    return (
        <div>
            {loading && (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Loading />
                </div>
            )}

            {inputInvalid && (
                <div style={styles.messageBox}>
                    No Information Available
                </div>
            )}

            {error && (
                <div style={styles.messageBox}>
                    {error}
                </div>
            )}

            {(!loading && documents.length === 0 && !error && !inputInvalid) && (
                <div style={styles.messageBox}>
                    No Information Available
                </div>
            )}

            {documents && documents.map(doc => (
                <div key={doc.id} style={{ marginBottom: '30px' }}>
                    <FileViewer base64Data={doc.base64Data} contentType={doc.contentType} />
                </div>
            ))}

            {/* Optional Refresh Button */}
            {/* <div style={{ textAlign: 'center' }}>
        <button onClick={handleRefresh}>Refresh Documents</button>
      </div> */}
        </div>
    );
}

const styles = {
    messageBox: {
        width: "100%",
        padding: '10px',
        margin: '10px 0',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '70vh'
    }
};
